/**
 * Boss/Goal data for path hint autocomplete.
 */
import Ghoma from '@/core/assets/oot/boss/OoT_Gohma.png';
import KingDodongo from '@/core/assets/oot/boss/OoT_King_Dodongo.png';
import Barinade from '@/core/assets/oot/boss/OoT_Barinade.png';
import PhantomGanon from '@/core/assets/oot/boss/OoT_Phantom_Ganon.png';
import Volvagia from '@/core/assets/oot/boss/OoT_Volvagia.png';
import Morpha from '@/core/assets/oot/boss/OoT_Morpha.png';
import BongoBongo from '@/core/assets/oot/boss/OoT_Bongo_Bongo.png';
import Twinrova from '@/core/assets/oot/boss/OoT_Twinrova.png';
import LightArrow from '@/core/assets/oot/classic/OoT_Light_Arrow_Icon.png';
import OcarinaOfTime from '@/core/assets/oot/classic/OoT_Ocarina_of_Time_Icon.png';
import Triforce from '@/core/assets/oot/classic/Triforce_Artwork.png';
import Bridge from '@/core/assets/oot/classic/bridge.jpg';

export interface GoalData {
  name: string;
  tags: string[];
  img: string;
}

export const BOSS_GOALS: GoalData[] = [
  { name: 'Ghoma', tags: ['Spider', 'Deku'], img: Ghoma },
  { name: 'King Dodongo', tags: ['KD', 'Goron'], img: KingDodongo },
  { name: 'Barinade', tags: ['Bari', 'Chateau'], img: Barinade },
  { name: 'Phantom Ganon', tags: ['PG', 'Forest'], img: PhantomGanon },
  { name: 'Volvagia', tags: ['KAK', 'Cocorico'], img: Volvagia },
  { name: 'Morpha', tags: ['Tentacule', 'Eau'], img: Morpha },
  { name: 'Bongo Bongo', tags: ['BB', 'Bongo'], img: BongoBongo },
  { name: 'Twinrova', tags: ['TR', 'Sorciere'], img: Twinrova },
  { name: 'Time', tags: [], img: OcarinaOfTime },
  { name: "Evil's Bane", tags: ['evil', 'la'], img: LightArrow },
  { name: 'Tower', tags: ['tower'], img: Bridge },
  { name: 'Gold', tags: ['Triforce'], img: Triforce },
];
